<div class="client-module" (window:resize)="_onResize()">
    <div class="container">
        <h3 class="wow fadeIn" data-wow-delay="1s">Aprovado por:</h3>
        <ul #slider>
            <li *ngFor="let l of data.clientes;let i=index;" class="wow slideInLeft" data-wow-delay="0.5s">
                <img [src]="l.logo" [alt]="l.name" width="120px" />
            </li>
        </ul>  
    </div>  
</div>   